export const IGNORE_GAMES = [
  "4K Spring Fling",
  "Super Graphics Super Lucky",
  "Super Lucky Frog",
  "Superola",
  "Mighty Black Knight",
  "Pearls of India",
  "Rage to Riches",
  "Sea Hunter",
  "Goldilocks and the Wild Bears",
  "Contact",
  "Tower Quest",
  "Troll Hunters",
  "Rainforest Magic",
  "Sails of Gold",
  "Gunslinger Reloaded",
  "Rise of Athena",
  "Phoenix Reborn",
  "Imperial Opera",
  "Fortunes of Ali Baba",
  "Feline Fury",
  "Planet Fortune",
  "Coils of Cash",
  "Fire Joker Freeze",
  "Golden Ticket 2",
  "Madame Ink",
  "Hotel Yeti-Way",
  "Fortune Rewind",
  "Pilgrim of Dead",
  "Fruits & Jokers: 20 Lines",
  "Magic Stars 3",
  "Royal Seven XXL Flaming Link",
  "Cash Cubes Trio Bonus",
  "Crown Blitz",
  "Roman Legion Flaming Link",
  "La Dolce Vita Flaming Link",
  "Book of Madness 2",
  "Dead Legion",
  "Blazing Bison Gold Blitz King Millions",
  "Cash Eruption Mines",
  "Frooty Troupe Sun Splash",
  "Explosive Frenzy",
  "Fruit Mania Flaming Link",
  "Royal Seven Flaming Link",
  "La Dolce Vita 2",
  "Train Strike Hold & Win"
]

export const LIVE_GAMES = [
  {
    name: "Lightning Storm",
    slug: "lightning-storm",
    url: "https://live101.egprom.com/app/41/amlst:lmwr1_auto/playlist.m3u8"
  },
  {
    name: "Roleta Relampago",
    slug: "roleta-relampago",
    url: "https://live101.egprom.com/app/10/amlst:lightmad1_imr_auto/playlist.m3u8"
  },
  {
    name: "Leo Roulette Show",
    slug: "leo-roulette-show",
    url: "https://live101.egprom.com/app/10/amlst:leom1_imr_auto/playlist.m3u8"
  },
  {
    name: "Video Poker Live",
    slug: "video-poker-live",
    url: "https://live101.egprom.com/app/20/amlst:pk_vpokr1_auto/playlist.m3u8"
  },
  {
    name: "Gold Vault Roulette",
    slug: "gold-vault-roulette",
    url: "https://live101.egprom.com/app/10/amlst:goldvk1_imr_auto/playlist.m3u8"
  },
  {
    name: "Lightning Lotto",
    slug: "lightning-lotto",
    url: "https://live101.egprom.com/app/44/amlst:lightltr1_mb_auto/playlist.m3u8"
  },
  {
    name: "Gonzo’s Treasure Map",
    slug: "gonzos-treasure-map",
    url: "https://live101.egprom.com/app/41/amlst:gtm_main_auto/playlist.m3u8"
  },
  {
    name: "Red Door Roulette",
    slug: "red-door-roulette",
    url: "https://live101.egprom.com/app/10/amlst:rdr_imr_auto/playlist.m3u8"
  },
  {
    name: "Funky Time Live",
    slug: "funky-time-live",
    url: "https://live101.egprom.com/app/43/amlst:fntk1_fnt_auto/playlist.m3u8"
  },
  {
    name: "Gold Bar Roulette",
    slug: "gold-bar-roulette",
    url: "https://live101.egprom.com/app/10/amlst:gldbark1_imr_auto/playlist.m3u8"
  },
  {
    name: "Gonzo's Treasure Hunt Live",
    slug: "gonzos-treasure-hunt-live",
    url: "https://live101.egprom.com/app/41/amlst:gth_main_auto/playlist.m3u8"
  },
  {
    name: "Extra Chilli Epic Spins",
    slug: "extra-chilli-epic-spins",
    url: "https://live101.egprom.com/app/44/amlst:exchk_es0_auto/playlist.m3u8"
  },
  {
    name: "Everybody's Jackpot Live",
    slug: "everybody-s-jackpot-live",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-evjp.smil/playlist.m3u8"
  },
  {
    name: "Crazy Coin Flip",
    slug: "crazy-coin-flip",
    url: "https://live101.egprom.com/app/43/amlst:gen_ccf1_auto/playlist.m3u8"
  },
  {
    name: "XXXTreme Lightning Roulette",
    slug: "xxxtreme-lightning-roulette",
    url: "https://live101.egprom.com/app/10/amlst:xfrt1_imr_auto/playlist.m3u8"
  },
  {
    name: "Deal or No Deal The Big Draw",
    slug: "deal-or-no-deal-the-big-draw",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-dond.smil/playlist.m3u8"
  },
  {
    name: "Money Drop Live",
    slug: "money-drop-live",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-mdl.smil/playlist.m3u8"
  },
  {
    name: "Fashion TV Jackpot Baccarat",
    slug: "fashion-tv-jackpot-baccarat",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-ftb.smil/playlist.m3u8"
  },
  {
    name: "Quantum Roulette Live",
    slug: "quantum-roulette-live",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-qr.smil/playlist.m3u8"
  },
  {
    name: "Mega Fire Blaze Roulette",
    slug: "mega-fire-blaze-roulette",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-mfb.smil/playlist.m3u8"
  },
  {
    name: "Monopoly Live",
    slug: "monopoly-live",
    url: "https://live101.egprom.com/app/43/amlst:mdc2_mw_en_auto/playlist.m3u8"
  },
  {
    name: "Live Lightning Dice",
    slug: "live-lightning-dice",
    url: "https://live101.egprom.com/app/42/amlst:light1_dice_auto/playlist.m3u8"
  },
  {
    name: "Cash or Crash",
    slug: "cash-or-crash",
    url: "https://live101.egprom.com/app/44/amlst:cocr1_mb_auto/playlist.m3u8"
  },
  {
    name: "Fan Tan",
    slug: "fan-tan",
    url: "https://live101.egprom.com/app/10/amlst:fntnr1_imr_auto/playlist.m3u8"
  },
  {
    name: "Quantum Blackjack",
    slug: "quantum-blackjack",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-qbj.smil/playlist.m3u8"
  },
  {
    name: "Hi-Lo",
    slug: "hi-lo",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-hil.smil/playlist.m3u8"
  },
  {
    name: "Buffalo Blitz Live",
    slug: "buffalo-blitz-live",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-bbs.smil/playlist.m3u8"
  },
  {
    name: "Age of the Gods Bonus Roulette",
    slug: "age-of-the-gods-bonus-roulette",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-aog.smil/playlist.m3u8"
  },
  {
    name: "Adventures Beyond Wonderland",
    slug: "adventures-beyond-wonderland",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-abw.smil/playlist.m3u8"
  },
  {
    name: "All Bets Blackjack",
    slug: "all-bets-blackjack",
    url: "https://leovegas-promo.cdn.ptlive.video/promo-leo-abb.smil/playlist.m3u8"
  },
  {
    name: "Live Lightning Baccarat",
    slug: "live-lightning-baccarat",
    url: "https://live101.egprom.com/app/30/amlst:lbac_bi_auto/playlist.m3u8"
  },
  {
    name: "Live Mega Ball",
    slug: "live-mega-ball",
    url: "https://live101.egprom.com/app/44/amlst:mbgenr1_mb_auto/playlist.m3u8"
  },
  {
    name: "Craps Live",
    slug: "craps-live",
    url: "https://live101.egprom.com/app/42/amlst:crpsr1_imr_auto/playlist.m3u8"
  },
  {
    name: "Leovegas Live Roulette",
    slug: "leovegas-live-roulette",
    url: "https://live101.egprom.com/app/10/amlst:leor1_imr_auto/playlist.m3u8"
  },
  {
    name: "Free Bet Blackjack",
    slug: "free-bet-blackjack",
    url: "https://live101.egprom.com/app/01/amlst:bj_fbetr1_auto/playlist.m3u8"
  },
  {
    name: "Leovegas Live Blackjack",
    slug: "leovegas-live-blackjack",
    url: "https://live101.egprom.com/app/03/amlst:bj_leor2_auto/playlist.m3u8"
  },
  {
    name: "Immersive Roulette",
    slug: "immersive-roulette",
    url: "https://live101.egprom.com/app/10/amlst:immersive_auto/playlist.m3u8"
  },
  {
    name: "Live Dream Catcher",
    slug: "live-dream-catcher",
    url: "https://live101.egprom.com/app/41/amlst:dc1_mw_auto/playlist.m3u8"
  },
  {
    name: "Crazy Time Live",
    slug: "crazy-time-live",
    url: "https://live101.egprom.com/app/43/amlst:dc3_ct_auto/playlist.m3u8"
  },
  {
    name: "Live Lightning Roulette",
    slug: "live-lightning-roulette",
    url: "https://live101.egprom.com/app/10/amlst:lightr1_imr_auto/playlist.m3u8"
  }
]

export const getLiveGameInfo = slug => {
  return LIVE_GAMES.find(game => game.slug.toLowerCase() === slug?.toLowerCase()) || null
}

export const normalizeGames = (list = [], mediaurl, imageKitUrl) => {
  return list.reduce((sum, item) => {
    const node = item.node || item

    const name = node?.name
    const slug = node?.attributes?.slug
    const url = node?.attributes?.images?.tile?.url
    const vertical = node?.attributes?.vertical

    if (!name || !slug || !url) return sum

    if (IGNORE_GAMES.includes(name)) return sum

    const liveGame = getLiveGameInfo(slug)

    // RULE 1: Live Casino but not in LIVE_GAMES → skip
    if (vertical === "Live Casino" && !liveGame) {
      return sum
    }

    const liveUrl = vertical === "Live Casino" && liveGame ? liveGame.url : url

    const thumbnail = mediaurl && url.startsWith(mediaurl) ? url.replace(mediaurl, imageKitUrl) : url

    return sum.concat({
      gameName: name,
      gameThumbnail: thumbnail,
      slug,
      url: liveUrl
    })
  }, [])
}
